// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__8cbjB","content":"NavBar_content__TkkW7"};